import { DIRECT_MESSAGE } from "../lib/constants/actions";
export const directMessage = (state = {}, action) => {
    switch (action.type) {
        case DIRECT_MESSAGE.FETCH_DIRECT_MESSAGE_SUCCESS:

            console.log('Hiiiii',action.payload)
            return { ...state, directMessageList: action.payload }

        case DIRECT_MESSAGE.DIRECT_MESSAGE_SUCCESS:
            return { ...state, directMessageSaved: action.payload }
        
        default:
            return state;
    }
};




